/** Public Estimation API — Faz 1.4 createApi factory. Public endpoint'ler. */
import {createApi} from './_factory'
import type {EstimationNs, ProjectNs} from '@shared/types'
import type {PublicNs} from '@shared/types/public.namespace'

const api = createApi('estimation-publish')
const noToast = {showErrorOnToaster: false}

const loadFeatures = (data: PublicNs.LoadProjectDataRequest) =>
  api.post<PublicNs.LoadProjectDataRequest, EstimationNs.FeatureEstimation[]>('features', data, noToast)

export const PublicEstimationApi = {
  checkToken: (data: PublicNs.CheckTokenRequest) =>
    api.post<PublicNs.CheckTokenRequest, ProjectNs.PublishProjectResponse>('validate-token', data, noToast),

  loadProjectData: (data: PublicNs.LoadProjectDataRequest) =>
    api.post<PublicNs.LoadProjectDataRequest, PublicNs.PublicEstimationData>('load-project-data', data, noToast),

  loadFeatureData: loadFeatures,

  /** @deprecated `loadFeatureData` ile aynı endpoint. Faz 4'te silinecek. */
  loadEstimationGroupData: loadFeatures,
}
